module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0073.jpg?v=efcbd16f";